import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import AestheticsSidebar from "../components/AestheticsSidebar";
import AestheticsGuard from "../components/AestheticsGuard";
import ReportsSubSidebar from "../components/ReportsSubSidebar";
import SettingsSubSidebar from "../components/SettingsSubSidebar";
import AestheticSettingsSubSidebar from "../components/aesthetics/AestheticSettingsSubSidebar";
import AestheticReportsSubSidebar from "../components/aesthetics/AestheticReportsSubSidebar";
import AestheticWebsiteSubSidebar from "../components/aesthetics/AestheticWebsiteSubSidebar";
import WebsiteSubSidebar from "../components/WebsiteSubSidebar";
import { AnimatePresence } from "framer-motion";

// Pages
import Dashboard from "../pages/Dashboard";
import BookingsPage from "../pages/Bookings";
import POS from "../pages/POS";
import Website from "../pages/website/Website";
import Reports from "../pages/Reports";
import Manage from "../pages/Manage";
import Customers from "../pages/Customers";
import Appointments from "../pages/customers/Appointments";
import CustomersSubSidebar from "../components/CustomersSubSidebar";
import Upgrades from "../pages/Upgrades";
import Settings from "../pages/Settings";
import CashUpDetail from "../components/CashUpDetail";
import DailySalesPage from "../pages/reports/DailySalesPage";
import ManageSubSidebar from "../components/ManageSubSidebar";
import Signup from "../pages/auth/signup";
import Login from "../pages/auth/login";
import ConsultationsPage from "../pages/Consultations";
import FormTemplatesPage from "../pages/FormTemplatePage";
import { AuthProvider } from "../auth/AuthContext";
import CategoriesPage from "../pages/manage/CategoriesPage";
import CategoriesPageNew from "../pages/manage/CategoriesPageNew";
import ServicesPage from "../pages/manage/ServicesPage";
import EmployeePage from "../pages/manage/EmployeePage";
import ScheduledShiftsPage from "../pages/manage/ScheduledShiftsPage";
import TimesheetPage from "../pages/manage/TimesheetPage";
import ServiceSettings from "../pages/ServiceSettings";
import ProductsPage from "../pages/manage/products/ProductsPage";
import SectionSettings from "../pages/website/SectionSettings";
import HeroSection from "../pages/website/HeroSection";
import Microsite from "../pages/website/Microsite";
import CalenderPage from "../pages/Calender";

// Settings Components
import ProfileSettings from "../pages/settings/ProfileSettings";
import GeneralSettings from "../pages/settings/GeneralSettings";
import AttachDomainSettings from "../pages/settings/AttachDomainSettings";
import XONDERSettings from "../pages/settings/XONDERSettings";
import VendorPageSettings from "../pages/settings/VendorPageSettings";
import BookingsSettings from "../pages/settings/BookingsSettings";
import QuickPaymentsSettings from "../pages/settings/QuickPaymentsSettings";
import SunbedSettings from "../pages/settings/SunbedSettings";
import PrinterSettings from "../pages/settings/PrinterSettings";


// Settings Components
import AestheticProfileSettings from "../pages/aesthetic-settings/AestheticProfileSettings";
import AestheticGeneralSettings from "../pages/aesthetic-settings/AestheticGeneralSettings";
import AestheticAttachDomainSettings from "../pages/aesthetic-settings/AestheticAttachDomainSettings";
import AestheticXONDERSettings from "../pages/aesthetic-settings/AestheticXONDERSettings";
import AestheticVendorPageSettings from "../pages/aesthetic-settings/AestheticVendorPageSettings";
import AestheticBookingsSettings from "../pages/aesthetic-settings/AestheticBookingsSettings";
import AestheticQuickPaymentsSettings from "../pages/aesthetic-settings/AestheticQuickPaymentsSettings";
import AestheticPrinterSettings from "../pages/aesthetic-settings/AestheticPrinterSettings";

// Contexts
import { SectionProvider } from "../context/SectionContext";
import { StepProvider } from "../context/StepContext";
import SuccessPage from "../pages/website/SuccessPage";
import FormBuilder from "../pages/forms/[id]/builder/FormBuilder";
import PublicFormPage from "../pages/PublicFormPage";
import GallerySection from "../pages/website/GallerySection";
import FooterSection from "../pages/website/FooterSection";
import AboutSection from "../pages/website/AboutSection";
import ServiceSection from "../pages/website/ServiceSection";
import TestimonialsSection from "../pages/website/TestomonialSection";
import FontandThemeSection from "../pages/website/FontandThemeSection";
import AboutUsPage from "../pages/website/AboutUsPage";
import TemplateSection from "../pages/website/TemplateSection";

// Auth Components
import PrivateRoute from "../components/PrivateRoute";
import PublicRoute from "../components/PublicRoute";
import SunbedSubSidebar from "../components/SunbedSubSidebar";
import SunbedPackages from "../pages/sunbeds/SunbedPackages";
import SunbedsPage from "../pages/sunbeds/SunbedsPage";
import CustomerPackages from "../pages/sunbeds/CustomerPackages";
import SunbedSessionPage from "../pages/SunbedSessionPage";
import ZReport from "../pages/reports/ZReport";
import ZReportDetail from "../pages/reports/ZReportDetail";
import XReport from "../pages/reports/XReport";
import SunbedReport from "../pages/reports/SunbedReport";
import ReportsDashboard from "../pages/reports/ReportsDashboard";
import SalesPage from "../pages/reports/SalesPage";
import PaymentsPage from "../pages/reports/PaymentsPage";
import AppointmentsReportPage from "../pages/reports/AppointmentsReportPage";

// Summary Pages
import EmployeesSummaryPage from "../pages/summary/EmployeesSummaryPage";
import ServicesSummaryPage from "../pages/summary/ServicesSummaryPage";
import ProductsSummaryPage from "../pages/summary/ProductsSummaryPage";
import CustomersSummaryPage from "../pages/summary/CustomersSummaryPage";
import BookingsSummaryPage from "../pages/summary/BookingsSummaryPage";
import CustomerDetailsPage from "../pages/summary/details/CustomerDetailsPage";
import EmployeeDetailsPage from "../pages/summary/details/EmployeeDetailsPage";
import ServiceDetailsPage from "../pages/summary/details/ServiceDetailPage";
import ProductDetailsPage from "../pages/summary/details/ProductDetailsPage";
import AestheticsNavbar from "../components/AestheticsNavbar";
import AestheticDashboard from "../pages/AestheticDashboard";
import AestheticBookings from "../pages/AestheticBookings";
import AestheticClientsPage from "../pages/AestheticClients";
import AestheticGallery from "../pages/AestheticGallery";
import AestheticPayments from "../pages/AestheticPayments";
import AestheticTreatments from "../pages/AestheticTreatments";
import AestheticTreatmentDetail from "../pages/AestheticTreatmentDetail";
import AestheticCalendar from "../pages/AestheticCalendar";
import AestheticPOS from "../pages/AestheticPOS";
import ClientDetailPage from "../components/aesthetics/clients/ClientDetailPage";
import AestheticSettings from "../pages/AestheticSettings";
import AestheticManage from "../pages/aesthetic/AestheticManage";
import AestheticManageSubSidebar from "../components/aesthetics/AestheticManageSubSidebar";
import ManageTreatments from "../pages/aesthetic/manage/ManageTreatments";
import ManagePractitioner from "../pages/aesthetic/manage/ManagePractitioner";
import AestheticReports from "../pages/aesthetic/AestheticReports";

// Aesthetic Report Pages
import AestheticReportsDashboard from "../pages/aesthetic/reports/ReportsDashboard";
import AestheticZReport from "../pages/aesthetic/reports/ZReport";
import AestheticXReport from "../pages/aesthetic/reports/XReport";
import AestheticDailySalesPage from "../pages/aesthetic/reports/DailySalesPage";
import AestheticSalesPage from "../pages/aesthetic/reports/SalesPage";
import AestheticPaymentsPage from "../pages/aesthetic/reports/PaymentsPage";
import AestheticAppointmentsReportPage from "../pages/aesthetic/reports/AppointmentsReportPage";
import AestheticCashUpPage from "../pages/aesthetic/reports/CashUpPage";
import AestheticZReportDetail from "../pages/aesthetic/reports/ZReportDetail";

// -------------------------------
// Layout wrapper (for app pages only)
// -------------------------------
const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  const isBookings = location.pathname.startsWith("/bookings");
  const isReports =
    location.pathname.startsWith("/reports") ||
    location.pathname.startsWith("/cashup");
  const isCustomers =
    location.pathname.startsWith("/customers") ||
    location.pathname.startsWith("/appointments");
  const isDailySales = location.pathname.startsWith("/daily-sales");
  const isManage = location.pathname.startsWith("/manage");
  const isServices = location.pathname.startsWith("/services");
  const isCategories = location.pathname.startsWith("/categories");
  const isEmployees = location.pathname.startsWith("/manage/employee");
  const isWebsiteModule = location.pathname.startsWith("/website");
  const isSettings = location.pathname.startsWith("/settings");
  const isSunbeds = location.pathname.startsWith("/sunbeds");
  const isPOS = location.pathname.startsWith("/pos");

  useEffect(() => {
    document.title = "Glossa - Smart Salon Management & Bookings";
  }, []);

  return (
    <div className="flex h-screen h-[100dvh] overflow-hidden">
      {/* Main Sidebar */}
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <div className="hidden lg:block">
        {(isManage || isServices || isCategories || isEmployees) && (
          <ManageSubSidebar />
        )}

        {/* Sub Sidebar only for Settings */}
        {isSettings && <SettingsSubSidebar />}

        {/* Sub Sidebar only for Sunbeds */}
        {isSunbeds && <SunbedSubSidebar />}

        {/* Sub Sidebar only for Website */}
        {isWebsiteModule && <WebsiteSubSidebar />}
      </div>

      <div className="flex flex-col flex-1 min-h-0 overflow-hidden">
        <Navbar onMobileMenuClick={() => setIsSidebarOpen(true)} />
        <div className="flex flex-1 flex-col lg:flex-row min-h-0">
          {/* Sub Sidebar only for Manage */}
          <div className="lg:hidden flex-shrink-0">
            {(isManage || isServices || isCategories || isEmployees) && (
              <ManageSubSidebar />
            )}

            {/* Sub Sidebar only for Settings */}
            {isSettings && <SettingsSubSidebar />}

            {/* Sub Sidebar only for Sunbeds */}
            {isSunbeds && <SunbedSubSidebar />}

            {/* Sub Sidebar only for Website */}
            {isWebsiteModule && <WebsiteSubSidebar />}
          </div>

          <div
            className={`flex-1 min-h-0 bg-gray-100 ${isPOS ? "overflow-hidden" : "overflow-y-auto"
              } ${isDailySales || isManage
                ? "pt-0 pr-0 pb-3 pl-0"
                : isReports
                  ? "pt-0 pr-3 pb-3 pl-3"
                  : isBookings
                    ? "pt-0 pr-6 pb-6 pl-6"
                    : isWebsiteModule
                      ? "pt-4 pr-6 pb-6 pl-6"
                      : location.pathname.startsWith("/dashboard") ||
                        location.pathname === "/"
                        ? "pt-0 pr-0 pb-6 pl-0"
                        : "pt-4 pr-6 pb-6 pl-6"
              }`}
          >
            <AnimatePresence mode="wait">
              <Routes
                location={location}
                key={
                  location.pathname.startsWith("/settings")
                    ? "/settings"
                    : location.pathname.startsWith("/website")
                      ? "/website"
                      : location.pathname
                }
              >
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />

                {/* Summary Routes */}
                <Route
                  path="/summary/employees"
                  element={<EmployeesSummaryPage />}
                />
                <Route
                  path="/summary/services"
                  element={<ServicesSummaryPage />}
                />
                <Route
                  path="/summary/products"
                  element={<ProductsSummaryPage />}
                />
                <Route
                  path="/summary/customers"
                  element={<CustomersSummaryPage />}
                />
                <Route
                  path="/summary/bookings"
                  element={<BookingsSummaryPage />}
                />

                {/* Summary Details Routes */}
                <Route
                  path="/summary/customers/:id"
                  element={<CustomerDetailsPage />}
                />
                <Route
                  path="/summary/employees/:id"
                  element={<EmployeeDetailsPage />}
                />
                <Route
                  path="/summary/services/:id"
                  element={<ServiceDetailsPage />}
                />
                <Route
                  path="/summary/products/:id"
                  element={<ProductDetailsPage />}
                />

                <Route path="/calendar" element={<CalenderPage />} />
                <Route path="/bookings" element={<BookingsPage />} />
                <Route path="/appointments" element={<Appointments />} />
                <Route path="/pos" element={<POS />} />
                <Route path="/website" element={<Website />} />

                <Route path="/consultation" element={<ConsultationsPage />} />
                {/* Please keep  it here  */}
                <Route
                  path="form-builder/:userId/:templateId"
                  element={<FormBuilder />}
                />
                <Route
                  path="/form-templates"
                  element={
                    <FormTemplatesPage
                    // onNavigateBack={() => window.history.back()}
                    />
                  }
                />
                <Route path="/form-templates" element={<FormTemplatesPage />} />
                <Route path="/cashup/:id" element={<CashUpDetail />} />
                <Route path="/daily-sales" element={<DailySalesPage />} />

                {/* Reports Routes */}
                <Route path="/reports" element={<Reports />} />
                {/* <Route path="/reports/dashboard" element={<ReportsDashboard />} />
              <Route path="/reports/sales" element={<SalesPage />} />
              <Route path="/reports/payments" element={<PaymentsPage />} />
              <Route path="/reports/appointments" element={<AppointmentsReportPage />} />
              <Route path="/reports" element={<Navigate to="/reports/dashboard" replace />} /> */}

                {/* Individual Report Routes (previously under /orders) */}
                {/* <Route path="/reports/z-report" element={<ZReport />} />
              <Route path="/reports/z-report/:id" element={<ZReportDetail />} />
              <Route path="/reports/x-report" element={<XReport />} />
              <Route path="/reports/sunbed-report" element={<SunbedReport />} /> */}
                <Route
                  path="/reports/z-report/:id"
                  element={<ZReportDetail />}
                />
                {/* Please keep  it here  */}

                <Route path="/manage" element={<Manage />} />
                <Route path="/manage/services" element={<ServicesPage />} />
                <Route
                  path="/manage/categories"
                  element={<CategoriesPageNew />}
                />
                <Route path="/manage/employee" element={<EmployeePage />} />
                <Route
                  path="/manage/employee/scheduled-shifts"
                  element={<ScheduledShiftsPage />}
                />
                <Route
                  path="/manage/employee/timesheets"
                  element={<TimesheetPage />}
                />
                <Route path="/categories" element={<CategoriesPage />} />
                <Route path="/service-settings" element={<ServiceSettings />} />
                <Route path="/manage/products" element={<ProductsPage />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/upgrades" element={<Upgrades />} />

                <Route path="/sunbeds">
                  <Route
                    index
                    element={<Navigate to="/sunbeds/packages" replace />}
                  />
                  <Route path="packages" element={<SunbedPackages />} />
                  <Route path="sunbeds" element={<SunbedsPage />} />
                  <Route
                    path="customer-packages"
                    element={<CustomerPackages />}
                  />
                </Route>
                <Route path="/sunbed-session" element={<SunbedSessionPage />} />

                {/* Settings Routes with nested routes */}
                <Route path="/settings" element={<Settings />}>
                  <Route
                    index
                    element={<Navigate to="/settings/profile" replace />}
                  />
                  <Route path="profile" element={<ProfileSettings />} />
                  <Route path="general" element={<GeneralSettings />} />
                  <Route
                    path="attach-domain"
                    element={<AttachDomainSettings />}
                  />
                  <Route path="xonder" element={<XONDERSettings />} />
                  <Route path="vendor-page" element={<VendorPageSettings />} />
                  <Route path="bookings" element={<BookingsSettings />} />
                  <Route
                    path="quick-payments"
                    element={<QuickPaymentsSettings />}
                  />
                  <Route path="sunbed-settings" element={<SunbedSettings />} />
                  <Route path="printer" element={<PrinterSettings />} />
                </Route>

                {/* Website Routes with nested routes */}
                <Route path="/website" element={<Website />}>
                  <Route
                    index
                    element={<Navigate to="/website/templatesection" replace />}
                  />
                  <Route
                    path="templatesection"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <TemplateSection />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  <Route
                    path="storesetting"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <SectionSettings />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  <Route
                    path="fronttheme"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <FontandThemeSection />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  <Route
                    path="herosection"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <HeroSection />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  <Route
                    path="aboutsection"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <AboutSection />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  {/* <Route
                  path="servicesection"
                  element={
                    <StepProvider>
                      <SectionProvider>
                        <ServiceSection />
                      </SectionProvider>
                    </StepProvider>
                  }
                /> */}
                  <Route
                    path="testimonialsection"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <TestimonialsSection />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  <Route
                    path="gallerysection"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <GallerySection />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  <Route
                    path="footersection"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <FooterSection />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  {/* <Route
                    path="successpage"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <SuccessPage />
                        </SectionProvider>
                      </StepProvider>
                    }
                  /> */}
                  <Route
                    path="aboutuspage"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <AboutUsPage />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                </Route>
              </Routes>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
};

// -------------------------------
// Aesthetics Layout (duplicate layout for /aesthetics routes)
// -------------------------------
const AestheticsLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  const isBookings = location.pathname.startsWith("/aesthetics/bookings");
  const isReports =
    location.pathname.startsWith("/aesthetics/reports") ||
    location.pathname.startsWith("/aesthetics/cashup");
  const isCustomers =
    location.pathname.startsWith("/aesthetics/customers") ||
    location.pathname.startsWith("/aesthetics/appointments");
  const isDailySales = location.pathname.startsWith("/aesthetics/daily-sales");
  const isManage = location.pathname.startsWith("/aesthetics/manage");
  const isServices = location.pathname.startsWith("/aesthetics/services");
  const isCategories = location.pathname.startsWith("/aesthetics/categories");
  const isEmployees = location.pathname.startsWith("/aesthetics/manage/employee");
  const isWebsiteModule = location.pathname.startsWith("/aesthetics/website");
  const isSettings = location.pathname.startsWith("/aesthetics/settings");
  const isSunbeds = location.pathname.startsWith("/aesthetics/sunbeds");
  const isPOS = location.pathname.startsWith("/aesthetics/pos");

  useEffect(() => {
    document.title = "Glossa Aesthetics - Smart Aesthetics Management & Bookings";
  }, []);

  return (
    <div className="flex h-screen h-[100dvh] overflow-hidden">
      {/* Main Sidebar */}
      <AestheticsSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <div className="hidden lg:block">
        {(isManage || isServices || isCategories || isEmployees) && (
          <AestheticManageSubSidebar />
        )}

        {/* Sub Sidebar only for Settings */}
        {isSettings && <AestheticSettingsSubSidebar />}

        {/* Sub Sidebar only for Reports */}
        {isReports && <AestheticReportsSubSidebar />}

        {/* Sub Sidebar only for Sunbeds */}
        {isSunbeds && <SunbedSubSidebar />}

        {/* Sub Sidebar only for Website */}
        {isWebsiteModule && <AestheticWebsiteSubSidebar />}
      </div>

      <div className="flex flex-col flex-1 min-h-0 overflow-hidden">
        <AestheticsNavbar onMobileMenuClick={() => setIsSidebarOpen(true)} />
        <div className="flex flex-1 flex-col lg:flex-row min-h-0">
          {/* Sub Sidebar only for Manage */}
          <div className="lg:hidden flex-shrink-0">
            {(isManage || isServices || isCategories || isEmployees) && (
              <AestheticManageSubSidebar />
            )}

            {/* Sub Sidebar only for Settings */}
            {isSettings && <AestheticSettingsSubSidebar />}

            {/* Sub Sidebar only for Reports */}
            {isReports && <AestheticReportsSubSidebar />}

            {/* Sub Sidebar only for Sunbeds */}
            {isSunbeds && <SunbedSubSidebar />}

            {/* Sub Sidebar only for Website */}
            {isWebsiteModule && <AestheticWebsiteSubSidebar />}
          </div>

          <div
            className={`flex-1 min-h-0 bg-gray-100 ${isPOS ? "overflow-hidden" : "overflow-y-auto"
              } ${isDailySales || isManage
                ? "pt-0 pr-0 pb-3 pl-0"
                : isReports
                  ? "pt-0 pr-3 pb-3 pl-3"
                  : isBookings
                    ? "pt-0 pr-6 pb-6 pl-6"
                    : isWebsiteModule
                      ? "pt-4 pr-6 pb-6 pl-6"
                      : location.pathname.startsWith("/aesthetics/dashboard") ||
                        location.pathname === "/aesthetics"
                        ? "pt-0 pr-0 pb-6 pl-0"
                        : "pt-4 pr-6 pb-6 pl-6"
              }`}
          >
            <AnimatePresence mode="wait">
              <Routes
                location={location}
                key={
                  location.pathname.startsWith("/aesthetics/settings")
                    ? "/aesthetics/settings"
                    : location.pathname.startsWith("/aesthetics/website")
                      ? "/aesthetics/website"
                      : location.pathname
                }
              >
                <Route path="/" element={<AestheticDashboard />} />
                <Route path="/dashboard" element={<AestheticDashboard />} />

                {/* Summary Routes */}
                <Route
                  path="/summary/employees"
                  element={<EmployeesSummaryPage />}
                />
                <Route
                  path="/summary/services"
                  element={<ServicesSummaryPage />}
                />
                <Route
                  path="/summary/products"
                  element={<ProductsSummaryPage />}
                />
                <Route
                  path="/summary/customers"
                  element={<CustomersSummaryPage />}
                />
                <Route
                  path="/summary/bookings"
                  element={<BookingsSummaryPage />}
                />

                {/* Summary Details Routes */}
                <Route
                  path="/summary/customers/:id"
                  element={<CustomerDetailsPage />}
                />
                <Route
                  path="/summary/employees/:id"
                  element={<EmployeeDetailsPage />}
                />
                <Route
                  path="/summary/services/:id"
                  element={<ServiceDetailsPage />}
                />
                <Route
                  path="/summary/products/:id"
                  element={<ProductDetailsPage />}
                />

                <Route path="/calendar" element={<AestheticCalendar />} />
                <Route path="/bookings" element={<AestheticBookings />} />
                <Route path="/appointments" element={<Appointments />} />
                <Route path="/pos" element={<AestheticPOS />} />
                <Route path="/website" element={<Website />} />

                <Route path="/consultation" element={<ConsultationsPage />} />
                <Route
                  path="form-builder/:userId/:templateId"
                  element={<FormBuilder />}
                />
                <Route
                  path="/form-templates"
                  element={<FormTemplatesPage />}
                />
                <Route path="/cashup/:id" element={<CashUpDetail />} />
                <Route path="/daily-sales" element={<DailySalesPage />} />

                {/* Reports Routes with nested routes */}
                <Route path="/reports" element={<AestheticReports />}>
                  <Route index element={<AestheticReportsDashboard />} />
                  <Route path="z-report" element={<AestheticZReport />} />
                  <Route path="z-report/:id" element={<AestheticZReportDetail />} />
                  <Route path="x-report" element={<AestheticXReport />} />
                  <Route path="daily-sales" element={<AestheticDailySalesPage />} />
                  <Route path="sales" element={<AestheticSalesPage />} />
                  <Route path="payments" element={<AestheticPaymentsPage />} />
                  <Route path="appointments" element={<AestheticAppointmentsReportPage />} />
                  <Route path="cash-up" element={<AestheticCashUpPage />} />
                </Route>

                <Route path="/manage" element={<AestheticManage />} />
                <Route path="/manage/treatments" element={<ManageTreatments />} />
                <Route path="/manage/practitioner" element={<ManagePractitioner />} />
                
                <Route path="/categories" element={<CategoriesPage />} />
                <Route path="/service-settings" element={<ServiceSettings />} />
                <Route path="/clients" element={<AestheticClientsPage />} />
                <Route path="/gallery" element={<AestheticGallery />} />
                <Route path="/payments" element={<AestheticPayments />} />
                <Route path="/clients/:id" element={<ClientDetailPage />} />
                <Route path="/treatments" element={<AestheticTreatments />} />
                <Route path="/treatments/:id" element={<AestheticTreatmentDetail />} />
                <Route path="/upgrades" element={<Upgrades />} />

                <Route path="/sunbeds">
                  <Route
                    index
                    element={<Navigate to="/aesthetics/sunbeds/packages" replace />}
                  />
                  <Route path="packages" element={<SunbedPackages />} />
                  <Route path="sunbeds" element={<SunbedsPage />} />
                  <Route
                    path="customer-packages"
                    element={<CustomerPackages />}
                  />
                </Route>
                <Route path="/sunbed-session" element={<SunbedSessionPage />} />

                {/* Settings Routes with nested routes */}
                <Route path="/settings" element={<AestheticSettings />}>
                  <Route
                    index
                    element={<Navigate to="/aesthetics/settings/profile" replace />}
                  />
                  <Route path="profile" element={<AestheticProfileSettings />} />
                  <Route path="general" element={<AestheticGeneralSettings />} />
                  <Route
                    path="attach-domain"
                    element={<AestheticAttachDomainSettings />}
                  />
                  <Route path="xonder" element={<AestheticXONDERSettings />} />
                  <Route path="vendor-page" element={<AestheticVendorPageSettings />} />
                  <Route path="bookings" element={<AestheticBookingsSettings />} />
                  <Route
                    path="quick-payments"
                    element={<AestheticQuickPaymentsSettings />}
                  />
                  <Route path="printer" element={<AestheticPrinterSettings />} />
                </Route>

                {/* Website Routes with nested routes */}
                <Route path="/website" element={<Website />}>
                  <Route
                    index
                    element={<Navigate to="/aesthetics/website/templatesection" replace />}
                  />
                  <Route
                    path="templatesection"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <TemplateSection />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  <Route
                    path="storesetting"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <SectionSettings />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  <Route
                    path="fronttheme"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <FontandThemeSection />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  <Route
                    path="herosection"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <HeroSection />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  <Route
                    path="aboutsection"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <AboutSection />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  <Route
                    path="testimonialsection"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <TestimonialsSection />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  <Route
                    path="gallerysection"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <GallerySection />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  <Route
                    path="footersection"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <FooterSection />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                  <Route
                    path="aboutuspage"
                    element={
                      <StepProvider>
                        <SectionProvider>
                          <AboutUsPage />
                        </SectionProvider>
                      </StepProvider>
                    }
                  />
                </Route>
              </Routes>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
};

// -------------------------------
// Main AppRoutes
// -------------------------------
const AppRoutes = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public routes (login/signup) - Redirect if already logged in */}
          <Route
            path="/signup"
            element={
              <PublicRoute>
                <Signup />
              </PublicRoute>
            }
          />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          {/* Microsite (public - no auth required) */}
          <Route
            path="/website/microsite/:userId"
            element={
              <SectionProvider>
                <Microsite />
              </SectionProvider>
            }
          />

          <Route
            path="/consultationform/:templateId"
            element={<PublicFormPage />}
          />

          {/* Protected aesthetics routes (require authentication + aesthetics access) */}
          <Route
            path="/aesthetics/*"
            element={
              <PrivateRoute>
                <AestheticsGuard>
                  <AestheticsLayout />
                </AestheticsGuard>
              </PrivateRoute>
            }
          />

          {/* Protected app routes (require authentication) */}
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default AppRoutes;